var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/screen-adapter/card-header-icon.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('img',{attrs:{"src":require("@/assets/screen-adapter/decorate.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }